import React, { useEffect, useState } from 'react';
import dayjs from 'dayjs';
import { useNavigate } from 'react-router-dom';

import { PDF_LIST_FIELDS } from 'constants/pdfListFields';
import { externalCalibrationService, pdfService } from 'services';
import { ExternalCalibration } from 'interfaces';
import { ROUTES } from 'constants/routes';
import { CustomButton, Spinner } from 'components';

import './PdfList.scss';

export const PdfList = () => {
  const [pdfList, setPdfList] = useState<[] | ExternalCalibration[]>([]);
  const [isPdfListLoading, setIsPdfListLoading] = useState<boolean>(false);
  const navigate = useNavigate();

  useEffect(() => {
    (async () => {
      setIsPdfListLoading(true);

      try {
        const response = await externalCalibrationService.getByUser();
        if (response) {
          setIsPdfListLoading(false);
          setPdfList(response);
        }
      } catch (e) {
        setIsPdfListLoading(false);
      }
    })();
  }, []);

  async function downloadExcel() {
    const response = await externalCalibrationService.excel();
    const fileURL = window.URL.createObjectURL(response as Blob);
    const alink = document.createElement('a');
    alink.href = fileURL;
    alink.download = `Calibrations_${new Date()
      .toISOString()
      .slice(0, 10)}.xlsx`;
    alink.click();
  }

  return (
    <div className="pdf-list-container">
      <div className="pdf-list__header-box">
        <h6 className="pdf-list__header">Calibration History</h6>
        <div>
          <CustomButton
            height="40px"
            text="Create calibration"
            marginRight="20px"
            onClick={() => navigate(ROUTES.create_authorized)}
          />
          <CustomButton
            height="40px"
            text="Export to Excel"
            onClick={() => downloadExcel()}
          />
        </div>
      </div>
      <div className="pdf-list__fields">
        {PDF_LIST_FIELDS.map(({ name }) => (
          <div key={name} className="pdf-list__field">
            <p className="pdf-list__text">{name}</p>
          </div>
        ))}
      </div>
      <div className="pdf-list__data-container">
        {pdfList.length !== 0 &&
          !isPdfListLoading &&
          pdfList.map(
            ({
              certificateNr,
              sn,
              dateOfCalibration,
              placeOfCalibration,
              imo,
              vessel,
              technician,
            }) => (
              <div key={certificateNr} className="pdf-list__data-box">
                <p className="pdf-list__data-item">{sn}</p>
                <p className="pdf-list__data-item">
                  {dayjs(dateOfCalibration).format('DD MMMM YYYY')}
                </p>
                <p className="pdf-list__data-item">{placeOfCalibration}</p>
                <p className="pdf-list__data-item">{imo}</p>
                <p className="pdf-list__data-item">{vessel}</p>
                <p className="pdf-list__data-item">{technician}</p>
                <p className="pdf-list__data-item">
                  <span
                    onClick={() =>
                      navigate(
                        `${ROUTES.documents_overview}/${sn}/${certificateNr}`
                      )
                    }
                  >
                    Details
                  </span>
                </p>
              </div>
            )
          )}
        {!pdfList.length && !isPdfListLoading && (
          <div className="pdf-list__empty">Your history is empty</div>
        )}
        {isPdfListLoading && (
          <div className="pdf-list__spinner-box">
            <Spinner />
          </div>
        )}
      </div>
    </div>
  );
};
